import gql from 'graphql-tag';

export default gql`
  fragment TravelerAncillaryOrderItemFragment on OrderItem {
    ... on TravelerAncillaryOrderItem {
      id
      flightId
      travelerId
      ancillaryType
      quantity
      price {
        amount
        currency
      }
      bundledAncillaryPrice {
        amount
      }
      isRemovable
      isBundledAncillaryIncluded
    }
  }
`;
